module.exports = __webpack_public_path__ + "img/silver.1a378d25.png";